import React from 'react'
import { useTranslation } from 'react-i18next'
import { BaseView, BaseText } from '@/components/base'
import { StickyHeaderNavigation } from '@/components/StickyHeaderNavigation'

interface IdentifierHeaderProps {
  translationKey: string
}

export const IdentifierHeader: React.FC<IdentifierHeaderProps> = ({
  translationKey,
}) => {
  const { t } = useTranslation()

  return (
    <BaseView gap={28}>
      {/* Back navigation could be added here if needed */}
      <StickyHeaderNavigation />
      <BaseText fontSize={32} className=" font-semibold text-left">
        {t(translationKey)}
      </BaseText>
    </BaseView>
  )
}
